<template>
  <div ref="filterPrice"
    class="filter-price">
    <div class="filter-price__value-list">
      <span ref="priceFrom"
        :class="{ '_handele-is-on-min': currentValueIsMin }">{{ minPriceValue }} &#8381; </span>
      <FormRange ref="formRange"
        class="filter-price__range"
        v-model="priceRange"
        :min="minPriceRange"
        :max="maxPriceRange"
        @update="onChange" />
      <span ref="priceTo">{{ maxPriceValue }} &#8381; </span>
    </div>
  </div>
</template>

<script>
import FormRange from "../form/FormRange.vue";
import { mapActions, mapState } from "pinia";
import { useFilterStore } from "@/store/filters/filterStore.js";
import { setParamsInUrl } from "@/plugins/helpers.js";

export default {
  name: "FilterPrice",
  components: { FormRange },
  emits: ["price-toggle"],

  data() {
    return {
      currentValueIsMin: true,
    };
  },
  computed: {
    ...mapState(useFilterStore, ["minPriceRange", "maxPriceRange", "minPriceValue", "maxPriceValue"]),
    priceRange: {
      async set(values) {
        await this.setMinMaxPriceValues(values);

        await setParamsInUrl(this, this.$route.query, {
          price: {
            min: values[0],
            max: values[1],
          },
        });
        this.emitter.emit("load-with-params");
      },
      get() {
        return [this.minPriceValue, this.maxPriceValue];
      },
    },
  },
  mounted() {
    this.formatCurrency();
    this.checkValueNow();
  },

  updated() {
    this.formatCurrency();
  },

  methods: {
    ...mapActions(useFilterStore, ["setMinMaxPriceValues", "setPriceInQuery", "returnRequiredParams"]),

    onChange() {
      this.formatCurrency();
      this.checkValueNow();
    },

    formatCurrency() {
      const priceFrom = this.$refs.priceFrom.textContent.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      const priceTo = this.$refs.priceTo.textContent.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      this.$refs.priceFrom.innerHTML = priceFrom;
      this.$refs.priceTo.innerHTML = priceTo;
    },

    checkValueNow() {
      const priceNow = this.$refs.filterPrice.querySelector("[aria-valuenow]");

      if (Number(priceNow.getAttribute("aria-valuenow")) === this.minPrice) {
        this.currentValueIsMin = true;
      } else {
        this.currentValueIsMin = false;
      }
    },
  },
};
</script>

<style lang="scss">
.filter-price {
  $that: &;

  min-width: 282px;
  padding: 0 28px 0 28px;
  border: 1px solid $color_grey-15;
  height: 48px;
  border-radius: 24px;

  @include tablet {
    height: 32px;
    display: flex;
    align-items: center;
  }

  &__name {
    font-size: 14px;
    line-height: 18px;
    color: $color-dark-40;
    padding-bottom: 4px;
    transform: translate3d(-8px, 0, 0);
  }

  &__range {
    min-width: 160px;
    height: 28px;
    background: transparent;
    border: 1px solid $color_grey-15;
    border-radius: 14px;
    padding-left: 16px;
    padding-right: 10px;

    @include tablet {
      min-width: 114px;
      height: 14px;
      padding: 0 6px;
    }
  }

  &__value-list {
    color: $white;
    transform: translate3d(-8px, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    gap: 32px;
    white-space: nowrap;

    @include tablet {
      gap: 18px;
      font-size: 12px;
      padding: 0;
    }

    .slider-horizontal {
      .slider-base {
        background: transparent !important;
      }

      .slider-handle {
        top: 0;
        height: 26px;
        width: 26px;
        border-radius: 50%;

        @include tablet {
          width: 12px;
          height: 12px;
          right: -6px;
        }
      }

      .slider-connect {
        background: transparent !important;
      }

    }

    span._handele-is-on-min {
      color: $color_dark-40;
    }
  }
}
</style>
